import http, { url } from '../../http'

const API_URL = "pbevidence"

class pbevidenceAPI {

  async save(pbevidence) {
    const response = await http(`${API_URL}/save`, 'POST', pbevidence)
    return response
  }
 
  async getAllpbevidence(id, page, search) {
    const response = await http(`${API_URL}/pbb/${id}?page=${page}&search=${search}` , 'POST')
    return response
  } 

  async getCapacitacion() {
    const response = await http(`training/indexNotPaginate`)
    return response
  } 
  
  async getpbevidence(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async updatepbevidence(id, pbevidence) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', pbevidence)
    return response
  }

  

 
  
}

export default new pbevidenceAPI()